import { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import "../pages/favourite.css";
export const SearchContainer = ({ title, handleSearch }) => {
  const [searchValue, setSearchValue] = useState(null);
  const debounceTimeout = useRef(null);

  const onChangeDebounce = useCallback(
    (e) => {
      setSearchValue(e.target.value);

      // Debounce the search
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        handleSearch(e.target.value);
      }, 500);
    },
    [handleSearch]
  );

  return (
    <div className="search-container">
      <p>{title}</p>

      <div className="search-bar">
        <i className="fa fa-search"></i>
        <input
          type="text"
          placeholder="Search"
          name="search"
          value={searchValue}
          onChange={onChangeDebounce}
        />
        {searchValue && (
          <button
            className="fa fa-times close-icon"
            style={{
              cursor: "pointer",
              border: "none",
              background: "transparent",
              margin: "5px"
            }}
            onClick={() => {
              setSearchValue("");
              handleSearch("");
            }}></button>
        )}
      </div>
    </div>
  );
};

SearchContainer.propTypes = {
  title: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired
};
